"use client";
import { Button, useComputedColorScheme } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import ContactSupportRounded from "@mui/icons-material/ContactSupportRounded";
import { useSession } from "next-auth/react";
import dynamic from "next/dynamic";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import CustomModal from "../../modals/CustomModal";
import ContactFormSkeleton from "./ContactFormSkeleton";
const ContactForm = dynamic(() => import("./ContactForm"), {
  loading: () => <ContactFormSkeleton />,
});

export default function ContactModule({
  type,
}: {
  type: "contact" | "feedback";
}) {
  const [opened, { open, close }] = useDisclosure(false);
  const title = type === "contact" ? "Contact Us" : "Send Feedback";
  const { data: session } = useSession();
  return (
    <>
      <CustomModal
        size="lg"
        title={title}
        TitleIcon={ContactSupportRounded}
        opened={opened}
        onClose={close}
      >
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
          scriptProps={{
            async: true,
            defer: true,
            appendTo: "head",
          }}
        >
          <ContactForm
            formId={"contactForm"}
            userName={session?.user.name}
            userEmail={session?.user.email}
          />
        </GoogleReCaptchaProvider>
      </CustomModal>
      <Button name={title} w={160} variant="filled" color="lightblue" onClick={open}>
        {title}
      </Button>
    </>
  );
}
